import React from "react";
import styled from "styled-components";
import nextholidayBg from "../../../assets/image/nextholidayBg.jpg";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  AttendaceTime,
  Empbx,
  EmpbxIicon,
  EmPortalLayout,
  EmpRound,
  HolidayCard,
  ProgressBar,
  ProgressBarContainer,
  ThumbChild,
  ThumbContainer,
  TimeBox,
  TimeBoxWhite,
} from "../../../pages/style";
import {
  Col,
  Divider,
  Flex,
  Gap,
  Icon,
  Row,
  Typography,
  Button,
  Box,
  Chip,
} from "../../../ppui";
import {
  TbCalendarTime,
  TbFileTime,
  TbFingerprint,
  TbLogout,
  TbMoneybag,
  TbUserCancel,
} from "react-icons/tb";
import { MdAccessTime } from "react-icons/md";
const ScreenLayout = styled.section({
  position: "relative",
  height: "100%",
  width: "100%",
  overflow: "hidden",
});

function EmployeePortalDashboard() {
  const leaves = [
    { type: "Casual Leaves", used: 6, total: 10 },
    { type: "Medical Leaves", used: 3, total: 10 },
    { type: "Privilege Leave", used: 8, total: 12 },
  ];

  const percentage = 65;
  const hoursWorked = 8;

  return (
    <>
      <EmPortalLayout>
        <ScreenLayout>
          <Row rowGap>
            <Col md={3}>
              <Empbx>
                <Flex
                  justifyContent="space-between"
                  alignItem="center"
                  gap={20}
                >
                  <Typography color="primary" variant="h6" mb="0">
                    Present
                  </Typography>

                  <EmpbxIicon>
                    <TbCalendarTime />
                  </EmpbxIicon>
                </Flex>
                <Gap height="20" />
                <Typography color="primary" variant="h3" mb="0">
                  20
                </Typography>

                <Typography
                  color="default"
                  variant="body2"
                  colorVariant="light"
                  mb="0"
                >
                  Days
                </Typography>
              </Empbx>
            </Col>

            <Col md={3}>
              <Empbx>
                <Flex
                  justifyContent="space-between"
                  alignItem="center"
                  gap={20}
                >
                  <Typography color="primary" variant="h5" mb="0">
                    Absent
                  </Typography>
                  <EmpbxIicon>
                    <TbUserCancel />
                  </EmpbxIicon>
                </Flex>
                <Gap height="20" />
                <Typography color="primary" variant="h3" mb="0">
                  2
                </Typography>

                <Typography
                  color="default"
                  variant="body2"
                  colorVariant="light"
                  mb="0"
                >
                  Days
                </Typography>
              </Empbx>
            </Col>

            <Col md={3}>
              <Empbx>
                <Flex
                  justifyContent="space-between"
                  alignItem="center"
                  gap={20}
                >
                  <Typography color="primary" variant="h5" mb="0">
                    Late
                  </Typography>
                  <EmpbxIicon>
                    <TbFileTime />
                  </EmpbxIicon>
                </Flex>
                <Gap height="20" />
                <Typography color="primary" variant="h3" mb="0">
                  1
                </Typography>

                <Typography
                  color="default"
                  variant="body2"
                  colorVariant="light"
                  mb="0"
                >
                  Days
                </Typography>
              </Empbx>
            </Col>

            <Col md={3}>
              <Empbx>
                <Flex
                  justifyContent="space-between"
                  alignItem="center"
                  gap={20}
                >
                  <Typography color="primary" variant="h5" mb="0">
                    Leave
                  </Typography>
                  <EmpbxIicon>
                    <TbLogout />
                  </EmpbxIicon>
                </Flex>
                <Gap height="20" />
                <Typography color="primary" variant="h3" mb="0">
                  0
                </Typography>

                <Typography
                  color="default"
                  variant="body2"
                  colorVariant="light"
                  mb="0"
                >
                  Days
                </Typography>
              </Empbx>
            </Col>
          </Row>

          <Gap height={40} />

          <Row>
            <Col md={8}>
              <AttendaceTime>
                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap={50}>
                      <Typography color="primary" variant="h6" strong mb="0">
                        Attendance
                      </Typography>

                      <Typography
                        color="default"
                        variant="h6"
                        colorVariant="light"
                        mb="0"
                      >
                        04-Dec-2024 Wednesday
                      </Typography>
                    </Flex>
                  </Col>
                  <Col md={"auto"} ml={"auto"}>
                    <Button
                      fullWidth
                      color="primary"
                      onClick={() => {}}
                      variant="outlined"
                    >
                      View All
                    </Button>
                  </Col>
                </Row>
                <Divider />
                <Box p={15}>
                  <Flex justifyContent="space-between">
                    <TimeBox>
                      <Icon size={"lg"} color={"primary"}>
                        <MdAccessTime />
                      </Icon>

                      <Typography color="dark" strong variant="body2" mb="0">
                        Log In
                      </Typography>
                    </TimeBox>

                    <TimeBox>
                      <Icon size={"lg"} color={"primary"}>
                        <MdAccessTime />
                      </Icon>

                      <Typography color="dark" strong variant="body2" mb="0">
                        Log Out
                      </Typography>
                    </TimeBox>
                  </Flex>

                  {/* Round-shape */}
                  <ThumbContainer>
                    {/* Circular Progress Bar */}
                    <CircularProgressbar
                      value={percentage}
                      strokeWidth={5}
                      styles={buildStyles({
                        pathColor: "#003f91",
                        trailColor: "#d9d9d9",
                        textColor: "#000",
                        textSize: "16px",
                        strokeLinecap: "butt",
                      })}
                    />
                    <ThumbChild>
                      {/* Center Content */}
                      <Flex alignItem="center" direction="column" gap={6}>
                        <EmpbxIicon>
                          <TbFingerprint />
                        </EmpbxIicon>

                        <Typography
                          color="dark"
                          variant="h4"
                          colorVariant="dark"
                          strong
                          mb="0"
                        >
                          Working
                        </Typography>

                        <Typography
                          color="dark"
                          variant="h4"
                          colorVariant="dark"
                          mb="0"
                        >
                          {hoursWorked}hr
                        </Typography>
                        <Button
                          size="sm"
                          color="primary"
                          onClick={() => {}}
                          variant="contained"
                        >
                          Logout
                        </Button>
                      </Flex>
                    </ThumbChild>
                  </ThumbContainer>
                  {/* Round-shape */}

                  <Flex justifyContent="space-between">
                    <TimeBoxWhite>
                      <Typography
                        align="center"
                        color="default"
                        variant="body1"
                        colorVariant="light"
                        mb="2"
                      >
                        Break Time
                      </Typography>
                      <Typography
                        align="center"
                        strong
                        variant="h6"
                        mb="0"
                        color="dark"
                        colorVariant="dark"
                      >
                        01.00 hr
                      </Typography>
                    </TimeBoxWhite>

                    <TimeBoxWhite>
                      <Typography
                        align="center"
                        color="default"
                        variant="body1"
                        colorVariant="light"
                        mb="2"
                      >
                        Overtime
                      </Typography>
                      <Typography
                        align="center"
                        strong
                        variant="h6"
                        mb="0"
                        color="dark"
                        colorVariant="dark"
                      >
                        02.00 hr
                      </Typography>
                    </TimeBoxWhite>
                  </Flex>
                </Box>
              </AttendaceTime>
            </Col>
            <Col md={4}>
              <AttendaceTime>
                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap={50}>
                      <Typography color="primary" variant="h6" strong mb="0">
                        Leave Information
                      </Typography>
                    </Flex>
                  </Col>
                  <Col md={"auto"} ml={"auto"}>
                    <Button
                      fullWidth
                      color="primary"
                      onClick={() => {}}
                      variant="outlined"
                    >
                      Apply Leave
                    </Button>
                  </Col>
                </Row>
                <Divider />

                <Row p={15} alignItem="center">
                  {leaves.map((leave, index) => (
                    <Col
                      md={4}
                      key={index}
                      style={{ textAlign: "center", padding: "0.875rem" }}
                    >
                      <CircularProgressbar
                        value={(leave.used / leave.total) * 100}
                        text={`${leave.used} / ${leave.total}`}
                        styles={buildStyles({
                          pathColor: "#004AA8",
                          textColor: "#000",
                          trailColor: "#d6d6d6",
                          textSize: "14px",
                          strokeLinecap: "butt",
                        })}
                      />
                      <Box>
                        <Typography
                          color="dark"
                          colorVariant="dark"
                          variant="h6"
                          mb="0"
                          mt="8"
                        >
                          {leave.type}
                        </Typography>
                      </Box>
                    </Col>
                  ))}
                </Row>
              </AttendaceTime>

              <HolidayCard
                p={15}
                mt={20}
                style={{
                  backgroundImage: `url(${nextholidayBg})`,
                }}
              >
                <Typography
                  color="light"
                  colorVariant="light"
                  variant="h6"
                  mb="9"
                >
                  Next Holiday
                </Typography>
                <Typography color="light" colorVariant="light" variant="body1">
                  Christmas, 25th December 2024
                </Typography>

                <Box mt="15" mb="10">
                  <Button
                    size="lg"
                    color="light"
                    onClick={() => {}}
                    variant="contained"
                  >
                    View All
                  </Button>
                </Box>
              </HolidayCard>
            </Col>
          </Row>
          <Gap height={40} />
          <Row>
            <Col md={4}>
              <AttendaceTime>
                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap={50}>
                      <Typography color="primary" variant="h6" strong mb="0">
                        Work Statistics
                      </Typography>
                    </Flex>
                  </Col>
                  <Col md={"auto"} ml={"auto"}>
                    <Button
                      fullWidth
                      color="primary"
                      onClick={() => {}}
                      variant="outlined"
                    >
                      View All
                    </Button>
                  </Col>
                </Row>
                <Divider />
                <Box p={15}>
                  <Box mb={20}>
                    <Flex
                      alignItem="center"
                      mb={10}
                      justifyContent="space-between"
                    >
                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        This Week
                      </Typography>

                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        28 / 40 hrs
                      </Typography>
                    </Flex>
                    <ProgressBarContainer>
                      <ProgressBar
                        style={{ backgroundColor: "#E98901", width: "50%" }}
                      ></ProgressBar>
                    </ProgressBarContainer>
                  </Box>

                  <Box mb={20}>
                    <Flex
                      alignItem="center"
                      mb={10}
                      justifyContent="space-between"
                    >
                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        This Month
                      </Typography>

                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        90 / 160 hrs
                      </Typography>
                    </Flex>
                    <ProgressBarContainer>
                      <ProgressBar
                        style={{ backgroundColor: "#71BB6A", width: "70%" }}
                      ></ProgressBar>
                    </ProgressBarContainer>
                  </Box>

                  <Box mb={20}>
                    <Flex
                      alignItem="center"
                      mb={10}
                      justifyContent="space-between"
                    >
                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        Overtime
                      </Typography>

                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        4 hrs
                      </Typography>
                    </Flex>
                    <ProgressBarContainer>
                      <ProgressBar
                        style={{ backgroundColor: "#004AA8", width: "60%" }}
                      ></ProgressBar>
                    </ProgressBarContainer>
                  </Box>

                  <Box mb={20}>
                    <Flex
                      alignItem="center"
                      mb={10}
                      justifyContent="space-between"
                    >
                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        Late
                      </Typography>

                      <Typography
                        color="dark"
                        colorVariant="dark"
                        variant="h6"
                        mb="0"
                      >
                        3 Days
                      </Typography>
                    </Flex>
                    <ProgressBarContainer>
                      <ProgressBar
                        style={{ backgroundColor: "#EA5743", width: "60%" }}
                      ></ProgressBar>
                    </ProgressBarContainer>
                  </Box>
                </Box>
              </AttendaceTime>
            </Col>
            <Col md={4}>
              <AttendaceTime>
                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap={50}>
                      <Typography color="primary" variant="h6" strong mb="0">
                        Loan Status
                      </Typography>
                    </Flex>
                  </Col>
                  <Col md={"auto"} ml={"auto"}>
                    <Button
                      fullWidth
                      color="primary"
                      onClick={() => {}}
                      variant="outlined"
                    >
                      View All
                    </Button>
                  </Col>
                </Row>
                <Divider />

                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap="10">
                      <EmpRound>
                        <TbMoneybag />
                      </EmpRound>

                      <Box>
                        <Typography
                          color="default"
                          colorVariant="light"
                          variant="body2"
                          mb="0"
                        >
                          Loan Type
                        </Typography>

                        <Typography
                          color="dark"
                          colorVariant="dark"
                          variant="h6"
                          mb="0"
                        >
                          Personal Loan
                        </Typography>
                      </Box>
                    </Flex>
                  </Col>
                  <Col xs={"auto"} ml={"auto"}>
                    <Chip
                      color="warning"
                      label="Pending"
                      onClick={() => {}}
                      size="sm"
                      variant="contained"
                    />
                  </Col>
                </Row>

                <Divider />

                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap="10">
                      <EmpRound>
                        <TbMoneybag />
                      </EmpRound>

                      <Box>
                        <Typography
                          color="default"
                          colorVariant="light"
                          variant="body2"
                          mb="0"
                        >
                          Loan Type
                        </Typography>

                        <Typography
                          color="dark"
                          colorVariant="dark"
                          variant="h6"
                          mb="0"
                        >
                          Personal Loan
                        </Typography>
                      </Box>
                    </Flex>
                  </Col>
                  <Col xs={"auto"} ml={"auto"}>
                    <Chip
                      color="warning"
                      label="Pending"
                      onClick={() => {}}
                      size="sm"
                      variant="contained"
                    />
                  </Col>
                </Row>
                <Divider />

                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap="10">
                      <EmpRound>
                        <TbMoneybag />
                      </EmpRound>

                      <Box>
                        <Typography
                          color="default"
                          colorVariant="light"
                          variant="body2"
                          mb="0"
                        >
                          Loan Type
                        </Typography>

                        <Typography
                          color="dark"
                          colorVariant="dark"
                          variant="h6"
                          mb="0"
                        >
                          Personal Loan
                        </Typography>
                      </Box>
                    </Flex>
                  </Col>
                  <Col xs={"auto"} ml={"auto"}>
                    <Chip
                      color="warning"
                      label="Pending"
                      onClick={() => {}}
                      size="sm"
                      variant="contained"
                    />
                  </Col>
                </Row>
                <Divider />

                <Gap height={40} />
              </AttendaceTime>
            </Col>
            <Col md={4}>
              <AttendaceTime style={{ height: "100%" }}>
                <Row p={15} alignItem="center">
                  <Col md={8}>
                    <Flex alignItem="center" gap={50}>
                      <Typography color="primary" variant="h6" strong mb="0">
                        Loan Status
                      </Typography>
                    </Flex>
                  </Col>
                </Row>
                <Divider />
              </AttendaceTime>
            </Col>
          </Row>
        </ScreenLayout>
      </EmPortalLayout>
    </>
  );
}

export default EmployeePortalDashboard;
